<p-dialog
  [visible]="visible()"
  (visibleChange)="handleVisibleChange($event)"
  [modal]="computedConfig().modal"
  [draggable]="computedConfig().draggable"
  [resizable]="computedConfig().resizable"
  [closable]="computedConfig().closable"
  [dismissableMask]="computedConfig().dismissableMask"
  [closeOnEscape]="computedConfig().closeOnEscape"
  [maximizable]="computedConfig().maximizable"
  [style]="dialogStyle()"
  [position]="computedConfig().position"
  [styleClass]="computedConfig().customClass"
  (onHide)="handleClose()"
>
  @if (computedConfig().showHeader && computedConfig().header) {
    <ng-template pTemplate="header">
      <div class="nexa-dialog-header-row">
        <h3 class="nexa-title">{{ computedConfig().header }}</h3>
        @if (computedConfig().headerExtra) {
          <span class="nexa-dialog-header-extra">{{ computedConfig().headerExtra }}</span>
        }
      </div>
    </ng-template>
  }

  <div [class]="computedConfig().contentClass">
    @if (content()) {
      <div [class.whitespace-pre-wrap]="computedConfig().preserveWhitespace" class="text-gray-900">
        {{ content() }}
      </div>
    } @else {
      <ng-content />
    }
  </div>

  @if (computedConfig().showFooter) {
    <ng-template pTemplate="footer">
      <div class="flex gap-2 justify-end">
        @for (button of computedConfig().footerButtons; track $index) {
          <p-button
            [label]="button.label"
            [severity]="button.severity"
            [icon]="button.icon"
            [outlined]="button.outlined"
            [disabled]="button.disabled"
            [style]="button.style"
            [attr.i18n-label]="button.i18n !== false ? '' : null"
            (onClick)="handleButtonClick(button)"
          />
        }
      </div>
    </ng-template>
  }
</p-dialog>
